const partybuildSystem = {
  path: '/partybuildSystem', // 主体
  name: 'partybuildSystem',
  redirect: '/zuzhijigou',
  component: () => import('../views/partybuildSystem/main'),
  children: [
    {
      path: '/partyBuilding',
      name: 'partyBuilding',
      meta: {
        title: '组织建设'
      },
      component: () => import ('../views/partybuildSystem/partyBuilding/index.vue'),
      children: [
        {
          path: '/zuzhijigou',
          name: 'zuzhijigou',
          meta: {
            title: '组织管理'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/zuzhijigou.vue'),
        },
        {
          path: '/organizationalBuilding',
          name: 'organizationalBuilding',
          meta: {
            title: '阵地建设'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/organizationalBuilding.vue'),
         },
         {
          path: '/partyBranchWork',
          name: 'partyBranchWork',
          meta: {
            title: '支部工作'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/partyBranchWork/regularWork.vue'),
         },
      ],
    },
    {
        path: '/partyBranchWork',
        name: 'partyBranchWork',
        meta: {
          title: '社区联合党委'
        },
          component: () => import('../views/partybuildSystem/partyBuilding/partyBranchWork/index.vue'),
          children: [
            {
              path: '/lianInfo',
              name: 'lianInfo',
              meta: {
                title: '社区联合党组织管理'
              },
              component: () => import('../views/partybuildSystem/partyBuilding/lianInfo/index.vue'),
              // redirect: '/CarePlan',
              children: [
                {
                  path: '/LHpartyOrgInfo',
                  name: 'LHpartyOrgInfo',
                  meta: {
                    title: '联合党委组织基本信息'
                  },
                  component: () => import('../views/partybuildSystem/partyBuilding/lianInfo/LHpartyOrgInfo.vue')
                },
                {
                  path: '/LHpartyMenberDw',
                  name: 'LHpartyMenberDw',
                  meta: {
                    title: '成员单位'
                  },
                  component: () => import('../views/partybuildSystem/partyBuilding/lianInfo/LHpartyMenberDw.vue')
                }
              ]
            },
            {
              path: '/LHregularWork',
              name: 'LHregularWork',
              meta: {
                title: '联合党委组织'
              },
              component: () => import('../views/partybuildSystem/partyBuilding/partyBranchWork/LHregularWork.vue'),
             },
          ]
    },
    {
      path: '/partyMemberManagementcopy',
      name: 'partyMemberManagementcopy',
      meta: {
        title: '党员管理'
      },
      component: () => import('../views/partybuildSystem/partyBuilding/partyMemberManagementcopy.vue'),
    }, 
    {
      path: '/sanhuiyike',
      name: 'sanhuiyike',
      meta: {
        title: '组织生活'
      },
      component: () => import('../views/partybuildSystem/partyBuilding/sanhuiyike.vue'),
    },  
    {
      path: '/TwoStudies',
      name: 'TwoStudies',
      meta: {
        title: '党员学习'
      },
      component: () => import('../views/partybuildSystem/partyBuilding/TwoStudies.vue'),
    },  
    {
      path: '/complaintAdvice',
      name: 'complaintAdvice',
      meta: {
        title: '工作计划'
      },
      component: () => import('../views/partybuildSystem/partyBuilding/complaintAdvice.vue'),
    }, 
    {
      path: '/teamWork',
      name: 'teamWork',
      meta: {
        title: '群团工作'
      },
      component: () => import ('../views/partybuildSystem/partyBuilding/teamWork/index.vue'),
      children: [
        {
          path: '/tissueDistributiont',
          name: 'tissueDistributiont',
          meta: {
            title: '组织分布'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/teamWork/tissueDistributiont.vue'),
        },
        {
          path: '/womenFederation',
          name: 'womenFederation',
          meta: {
            title: '妇联工作'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/teamWork/womenFederation.vue'),
         },
         {
          path: '/youthWork',
          name: 'youthWork',
          meta: {
            title: '共青团工作'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/teamWork/youthWork.vue'),
         },
         {
          path: '/careNextGeneration',
          name: 'careNextGeneration',
          meta: {
            title: '关系下一代'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/teamWork/careNextGeneration.vue'),
         },
         {
          path: '/tradeUnionWork',
          name: 'tradeUnionWork',
          meta: {
            title: '工会工作'
          },
          component: () => import('../views/partybuildSystem/partyBuilding/teamWork/tradeUnionWork.vue'),
         },
      ],
    },
  ]
}
export default partybuildSystem